module.exports = __webpack_public_path__ + "static/media/tabby_write_goal.62439169.png";